<template>
    <section id="landing">
        <section class="side-padding">
            <div v-if="showPopularSearches">
                <h2>{{ $t(`home_page.${site}.popular_title`) }}</h2>
                <!-- list -->
                <ul class="popular-searches horizontal-list">
                    <li v-for="t in popularSearches" v-bind:key="t.title">
                        <router-link :to="{ path: `/?q1=all::${t.search_query}` }" class="block-link">
                            <img :src="getImage(t.image)" :alt="t.title">
                            <span class="h3">
                                <span>{{ t.title }}</span>
                            </span>
                        </router-link>
                    </li>
                </ul>
            </div>

            <div v-if="hasCollections" class="featured">
                <h2>
                    <router-link :to="{ name: 'collections' }" class="nav-link" v-if="hasCollections">
                        {{ $t('menu.collections') }}
                    </router-link>
                </h2>
                <p>{{ $t(`home_page.${site}.collections_lead_in`) }}</p>

                <ul class="collections horizontal-list">
                    <li v-for="t in featuredCollections" v-bind:key="t.title">
                        <a :href="$router.resolve({ path: `${advRoute}?${t.search_query}` }).href" class="block-link">

                            <img :src="getImage(t.image)" :alt="t.title">
                            <span class="h3">
                                <span>{{ t.title }}</span>
                            </span>
                        </a>
                    </li>
                </ul>
            </div>
        </section>
        <section>
            <ResourceCenter></ResourceCenter>
            <SearchingForMore></SearchingForMore>
        </section>

        <JsonLD></JsonLD>
    </section>
</template>

<script>
import JsonLD from '../components/JsonLD'
import ResourceCenter from '../components/ResourceCenter'
import SearchingForMore from '../components/SearchingForMore'
import { mapGetters } from 'vuex'

export default {
    components: {
        JsonLD,
        ResourceCenter,
        SearchingForMore
    },
    computed: {
        ...mapGetters({
            'site': 'search/site'
        }),
        showPopularSearches() {
            return this.$i18n.messages[this.$i18n.locale].home_page[this.site].show_popular_searches;
        },
        popularSearches() {
            let searches = this.$i18n.messages[this.$i18n.locale].home_page[this.site].popular_searches;
            return searches;
        },
        featuredCollections() {
            let hasCollections = this.$i18n.messages[this.$i18n.locale].home_page[this.site].featured_collections;
            if (hasCollections) {
                let collections = this.$i18n.messages[this.$i18n.locale].collections_page[this.site].collections;
                const stickyHightlight = collections.filter((collection) => collection.sticky_hightlight == 'true')
                const remainingHighlight = collections.filter((collection) => collection.sticky_hightlight != 'true')

                const shuffled = remainingHighlight.sort(() => 0.5 - Math.random());
                let randomOtherTwo = shuffled.slice(0, 2);

                const totalHighlight = stickyHightlight.concat(randomOtherTwo)

                return totalHighlight;
            } else {
                return [];
            }
        },
        hasCollections() {
            return this.featuredCollections.length;
        },
        basicRoute() {
            return this.$i18n.messages[this.$i18n.locale].routes.basic_search;
        },
        advRoute() {
            return this.$i18n.messages[this.$i18n.locale].routes.advanced_search;
        }
    },
    methods: {
        getImage(path) {
            try {
                let img = require(`@/assets/${path}`);
                return img;
            } catch (e) {
                return '';
            }
        }
    }
}
</script>

<style scoped lang="scss">
#landing {
    margin-top: $s4;
}

.horizontal-list {

    &.popular-searches {
        li {
            flex-basis: 25%;
            height: 18vw;
        }
    }

    &.collections {
        li {
            flex-basis: 33%;
            width: 30vw;
            height: 30vw;

            a {
                span {
                    bottom: 2.275rem;
                }

                .h3 {
                    transition: background 250ms;

                    &:hover {
                        background: rgba(0, 0, 0, .4);
                    }
                }
            }
        }
    }

}


.featured {
    margin-top: $s3;

    p {
        max-width: $max-text-width;
    }

    a {
        color: $dark-gray1;
        text-decoration: none;
    }
}

@media (max-width: $mq-max-width-tablet) {
    #landing {
        margin-top: $s2;
    }
}

@media (max-width: $mq-max-width-mobile) {
    .horizontal-list {
        flex-direction: column;

        &.collections {
            li {
                padding-left: 0;
                padding-right: 0;
                flex-basis: 100%;
                width: 100%;
                max-height: 300px;
            }
        }
    }
}
</style>